import { createIdbStore } from '@/lib/idb-store';

export interface AssignmentResolveDraftRecord {
  body: string;
  attachments: File[];
  updatedAt: number;
}

export const assignmentResolveDraftStore = createIdbStore<AssignmentResolveDraftRecord>('assignment-resolve-drafts', 'drafts');
